export default {
  title: 'Feedback · {stage}',
  reportVersion: 'Report version',
  latest: 'latest',
  feedbackOn: 'Feedback on {stage}',
  hint: 'No messages yet. Write your comments while you go through the report; the NG team will answer them here.',
  downloadDeliverable: 'Download {name}',
  you: 'You',
  staff: 'NG team',
  onReport: 'Written on report v{version} · click to show it',
  edit: 'Edit',
  delete: 'Delete',
  edited: 'Edited {date}',
  deleted: 'Message deleted by {name} · {date}',
  deleteConfirm: 'Delete this message? Everyone will see that you deleted it.',
  placeholder: 'Write a message…',
  sendHint: '⌘/Ctrl + Enter to send',
  cancel: 'Cancel',
  send: 'Send',
  save: 'Save',
  discardConfirm: 'Discard your unsent message?',
  errorSaving: 'The message could not be saved. Please try again.',
  errorDeleting: 'The message could not be deleted. Please try again.',
  dividerHint: 'Drag to resize · click to hide the feedback',
  showFeedback: 'Show feedback',
  feedbackTab: 'Feedback'
}
